import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./ComplexGuide.module.scss";
import Header from "../../components/Header/Header";
import MenuBar from "../../components/MenuBar/MenuBar";
import Footer from "../../components/Footer/Footer";
import Bener from "../../components/Bener/Bener";
import FixIcon from "../../components/FixIcon/FixIcon";
import { Helmet } from "react-helmet-async";


import page1 from "../../assets/ComplexGuide/ComplexGuide3/page1.jpg";



const ComplexGuide3 = () => {
  const menuContents = [
    { title: "단지 배치도", url: "/ComplexGuide/intro" },
    { title: "호수 배치도", url: "/ComplexGuide/detailintro" },
    { title: "커뮤니티", url: "/ComplexGuide/community" },
  ];
  const [isScroll, setIsScroll] = useState(false);
  const [isImage2Loaded, setIsImage2Loaded] = useState(false); // 이미지 로딩 상태 추가
  const { pathname } = useLocation(); // 현재 경로를 가져옴

  // 이미지가 로드되면 호출되는 함수
  const handleImageLoad = () => {
    setIsImage2Loaded(true); // 이미지가 로드되면 상태 업데이트
  };

  useEffect(() => {
    window.scrollTo(0, 0); // 페이지가 로드될 때 스크롤을 최상단으로 이동
  }, [pathname]); // pathname이 변경될 때마다 실행

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScroll(true);
      } else {
        setIsScroll(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={styles.container}>
<Helmet>
  <title>평택 화양 서희스타힐스 - 커뮤니티</title>
  <meta
    name="description"
    content="평택 화양 서희스타힐스 커뮤니티 안내. 단지 내 다양한 커뮤니티 시설과 입주민을 위한 생활 편의 공간을 확인하세요."
  />
  <link rel="canonical" href="https://www.leecols.kr/ComplexGuide/community" />
  <meta name="robots" content="index,follow" />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="평택 화양 서희스타힐스" />
  <meta property="og:title" content="평택 화양 서희스타힐스 - 커뮤니티" />
  <meta
    property="og:description"
    content="평택 화양 서희스타힐스 커뮤니티 페이지에서 단지 내 다양한 편의시설과 생활 공간을 확인하세요."
  />
  <meta property="og:url" content="https://www.leecols.kr/ComplexGuide/community" />
  <meta property="og:image" content="https://www.leecols.kr/img/og/complex.jpg" />
</Helmet>

<Header isChanged={isScroll} />
<FixIcon />
<Bener title="커뮤니티" />
<MenuBar contents={menuContents} />

<h1 className={styles.screenReaderOnly}>
  평택 화양 서희스타힐스 커뮤니티
</h1>
<p className={styles.screenReaderOnly}>
  평택 화양 서희스타힐스의 커뮤니티 페이지입니다.
  단지 내 다양한 편의시설과 입주민을 위한 생활 공간 정보를 확인할 수 있습니다.
</p>

<div className={styles.textBox}>
  <div>화양지구의 새로운 주거 중심</div>
  <div>평택 화양 서희스타힐스 커뮤니티</div>
</div>

{/* 이미지에 애니메이션 효과 추가 */}
<img
  className={`${styles.image2} ${isImage2Loaded ? styles.showImage2 : ''}`}
  src={page1}
  alt="평택 화양 서희스타힐스 커뮤니티 안내"
  onLoad={handleImageLoad}  // 이미지 로드 후 애니메이션 실행
/>

      <div className={styles.commonBox}>
              <div className={styles.notice}>
                ※ 커뮤니티 이미지는 소비자의 이해를 돕기 위한 것으로 실제와 차이가 날 수 있습니다
              </div>
              <div className={styles.notice}>
                ※ 커뮤니티내 조경 및 세부계획, 시설물의 위치는 실제 시공시 현장 상황에 따라 변경될 수 있습니다
              </div>
            </div>

      <Footer />
    </div>
  );
};

export default ComplexGuide3;
